export default __webpack_public_path__ + "static/media/right.8a992bdc.svg";